import { useState } from 'react';
import { Outlet } from 'react-router-dom';
// @mui
import { styled } from '@mui/material/styles';
//
import Header from './header';
import Nav from './nav';

// ----------------------------------------------------------------------

const APP_BAR_MOBILE = 64;
const APP_BAR_DESKTOP = 48;

const StyledRoot = styled('div')({
  display: 'flex',
  minHeight: '100%',
  overflow: 'hidden',
});

const Main = styled('div')(({ theme }) => ({
  flexGrow: 1,
  width:'100%',
  overflow: 'auto',
  minHeight: '100%',
  paddingTop: APP_BAR_MOBILE + 24,
  paddingBottom: theme.spacing(10),
  [theme.breakpoints.up('lg')]: {
    paddingTop: APP_BAR_DESKTOP,
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
  },
}));

// ----------------------------------------------------------------------
import { useSelector } from 'react-redux';
export default function DashboardLayout() {
  const [open, setOpen] = useState(false);
  const cola = useSelector(state=>state.appState.menu_collapsed);
  return (
    <StyledRoot>
      <Header onOpenNav={() => setOpen(cola)} />

      <Nav openNav={cola} onCloseNav={() => setOpen(!cola)} />

      <Main>
        <Outlet />
      </Main>
    </StyledRoot>
  );
}
